import { Box, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, MouseEvent, useContext } from 'react';
import { LanguageContext } from '../../../contexts/LanguageContext/languageContext';
import { colors } from '../../../styles/theme';
import TGTooltip from '../../TGTooltip';

export const ActionButton = ({
  action,
  label = '',
  icon,
  style,
  disabled = false,
  disabledText = '',
}: {
  action: (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => void;
  label?: string;
  style?: CSSProperties;
  icon: React.ReactElement<any, string | React.JSXElementConstructor<any>> | undefined;
  disabled?: boolean;
  disabledText?: string;
}) => {
  const classes = useStyles();
  const { translate } = useContext(LanguageContext);

  const handleClick = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    if (!disabled) action(e);
  };

  const content = (
    <Box className={clsx(classes.iconContainer, { [classes.disabledContainer]: disabled })} onClick={handleClick}>
      <Box className={classes.actionIcon}>{icon}</Box>
      <Typography className={classes.title} style={style}>
        {translate(label)}
      </Typography>
    </Box>
  );

  return disabled ? <TGTooltip title={translate(disabledText)}>{content}</TGTooltip> : content;
};

const useStyles = makeStyles(theme => ({
  iconContainer: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 5,
  },
  actionIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: `0px 2px 4px 0px ${colors.black10}`,
    backgroundColor: colors.white,
    '& div': {
      marginRight: '0px !important',
    },
    '& svg': {
      fontSize: 20,
      color: theme.palette.secondary.main,
    },
  },
  title: {
    fontSize: 13,
    fontFamily: 'Roboto',
    lineHeight: '17px',
    letterSpacing: -0.5,
    fontWeight: 400,
    textAlign: 'center',
  },
  disabledContainer: {
    cursor: 'default',
    opacity: 0.5,
  },
}));
